import React, { useEffect, useState } from 'react';
import ChevronLeftIcon from 'components/atoms/icons/chevronLeft';
import classNames from 'classnames';
import CollapseAnimation from 'components/atoms/base-animations/collapse';
import { Link, useLocation } from 'react-router-dom';
import { Badge } from 'antd';

import s from './styles.module.scss';

import type { IDropdownLinks } from '../types';

interface IProps {
  data: IDropdownLinks;
}

const MobileHeaderMenus: React.FC<IProps> = (props) => {
  const { data } = props;

  const location = useLocation();

  const [opened, setOpened] = useState(false);

  const toggleOpened = () => {
    setOpened(!opened);
  };

  useEffect(() => {
    if (opened) setOpened(false);
  }, [location.pathname]);

  return (
    <>
      <li
        className={classNames(s.item, {
          [s.active]: opened,
        })}
        onClick={toggleOpened}
        data-cy={data.dataCy}
      >
        {data.label}
        <i className={s.i}>
          <ChevronLeftIcon
            className={classNames(s.icon, {
              [s.rotate]: opened,
            })}
          />
        </i>
      </li>
      <CollapseAnimation opened={opened}>
        <ul className={s.group}>
          {data.links.map((linkGroup) =>
            linkGroup.map((link) => (
              <Link key={link.link} to={link.link} data-cy={link.dataCy}>
                <li className={s.item}>
                  {link.label}
                  {link.badgeCount != null && link.badgeCount > 0 && (
                    <Badge
                      count={link.badgeCount}
                      size="small"
                      className={s['badge-count']}
                    />
                  )}
                </li>
              </Link>
            )),
          )}
        </ul>
      </CollapseAnimation>
    </>
  );
};

export default MobileHeaderMenus;
